"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Address__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "address",
    name: "target",
    type: "address"
  }],
  name: "AddressEmptyCode",
  type: "error"
}];
const _bytecode = "0x60566050600b82828239805160001a6073146043577f4e487b7100000000000000000000000000000000000000000000000000000000600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212205487ff8607ecb2207453460454955f7343ae3ac695fd1a0e1bf00b4065a17bcc64736f6c63430008160033";
const isSuperArgs = xs => xs.length > 1;
class Address__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.Address__factory = Address__factory;
_defineProperty(Address__factory, "bytecode", _bytecode);
_defineProperty(Address__factory, "abi", _abi);